import { render } from "./NavigationStats.vue?vue&type=template&id=35e993b9&scoped=true&ts=true"
import script from "./NavigationStats.vue?vue&type=script&lang=ts"
export * from "./NavigationStats.vue?vue&type=script&lang=ts"

import "./NavigationStats.vue?vue&type=style&index=0&id=35e993b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e993b9"]])

export default __exports__